
import React from 'react'

import HeroHome from '../components/Hero/hero-home'
import HeroSub from '../components/Hero/hero-sub'

import { convertComponents } from '../components/factory'
import { getLocalization } from '../localization'

import '../fragments'


class SubPage extends React.Component {

  renderHero(page, localization, lang) {
    if (!page.hero) {
      return null
    }

    return page.title.toLowerCase() === 'home' ? 
      <HeroHome content={page.hero} lang={lang} localization={localization}></HeroHome> : 
      <HeroSub content={page.hero} lang={lang} localization={localization}></HeroSub>
  }

  render() {
    const page = this.props.data.contentfulPage || this.props.data
    const locale = page.node_locale
    const localization = getLocalization(this.props.data.globalLocalization || this.props.localization, locale)
    const lang = locale.substring(0, 2)

    if (!page.content) {
      return null
    }
    
    const components = convertComponents({ components: page.content, lang, localization, news: this.props.news })
    const header = this.renderHero(page, localization, lang)

    return (
      <div className="subpage-container" data-cy="subpage">
        {header}
        {components}
      </div>
    )
  }
}


export default SubPage

export const pageQuery = graphql`
query pageQuery( $id : String!) {
  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  contentfulPage: contentfulPage(id: {eq: $id}) {
    id
    node_locale
    title
    ...HeroFragment
    ...PageFragment
  }
}
`


// WEBPACK FOOTER //
// ./src/templates/subpage.js